import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-time-picker-dropdown',
  templateUrl: './time-picker-dropdown.component.html',
  styleUrls: ['./time-picker-dropdown.component.scss']
})
export class TimePickerDropdownComponent {
  @Input() dates: { text: string, value: number }[] = [];
  @Output() handleSubmitResponse = new EventEmitter();
  @ViewChild('myDropdown') myDropdown!: NgbDropdown;


  onDateSelect(data:any){
    this.handleSubmitResponse.emit(data);
    this.myDropdown.close();

  }

}
